import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=56500c92&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=56500c92&prod&lang=scss"
import style1 from "./SearchBar.vue?vue&type=style&index=1&id=56500c92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../common/temp/node_modules/.pnpm/vue-loader@15.11.1_qty7iymlffgpukvncpluvycwfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56500c92",
  null
  
)

export default component.exports